import React from 'react';
import Loader from './Loader';
import { useStoredDataChanged } from './useStoredDataChanged';
import { fetchEventLeads } from '../../data/fetch';

export default function LoadLeads(props) {
    const { eventId, children } = props;

    useStoredDataChanged();

    return <Loader promises={[fetchEventLeads(eventId)]}>{children}</Loader>;
}
